// Icona "catena di persone che si tengono per mano" (stile ritaglio origami), lucide-like.
// stroke currentColor, viewBox 24. Uso: <PeopleChainIcon className="h-5 w-5 ..." />
export const PeopleChainIcon = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <circle cx="4" cy="5" r="2" />
    <circle cx="12" cy="5" r="2" />
    <circle cx="20" cy="5" r="2" />
    <path d="M4 7v7" />
    <path d="M12 7v7" />
    <path d="M20 7v7" />
    <path d="M4 9.5C5.2 11 6.5 11.7 8 11.7s2.8-.7 4-2.2c1.2 1.5 2.5 2.2 4 2.2s2.8-.7 4-2.2" />
    <path d="M4 14l-1.8 6" />
    <path d="M4 14l1.8 6" />
    <path d="M12 14l-1.8 6" />
    <path d="M12 14l1.8 6" />
    <path d="M20 14l-1.8 6" />
    <path d="M20 14l1.8 6" />
  </svg>
);

export default PeopleChainIcon;
